<template>
  <div id="contact">
    <h1>Get In Touch</h1>
    <p>Here are the best ways to contact me:</p>
    <div id="contact-options">
      <a href="mailto:bensheltonjones@gmail.com">Email</a>
      <a href="https://github.com/benshelton">GitHub</a>
      <a href="https://www.linkedin.com/in/bensheltonjones/">LinkedIn</a>
    </div>
    <h1>Looking To Hire?</h1>
    <p>I'm a proud member of <a href="https://www.toptal.com/#meet-nothing-but-impressive-hackers">Toptal</a> and currently source most of my work through them.</p>
    <p>You can view my online profile <a href="https://www.toptal.com/resume/ben-jones#meet-nothing-but-impressive-hackers">here</a></p>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue